import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useModal } from 'context/ModalContext';

import { CAMPO_DA_ACAO, ConfirmacaoDaAcao, ResultadoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

export default function ModalFeedback(props: Props) {
  const modalID = 'validation-feedback';

  const [message, setMessage] = useState<string>();

  const { openModal, closeModal } = useModal();
  const { callback, id, data } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);

  function handleSubmit() {
    if (typeof message === 'string' && message.trim().length) {
      if (message.trim().length > 200 || message.trim().length < 20) {
        return toast(
          `Seu feedback não pode ter menos de 20 caracteres ou mais de 200 caracteres. Você digitou ${message.trim().length} ${
            message.trim().length > 1 ? `caracteres` : `caracter`
          }.`,
          {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'error',
          },
        );
      }

      callback({ id: 'feedback', message: message.trim() });
      setSuccess(true);
    }
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setMessage(undefined);
      setSuccess(false);
      setIsOpen(true);
    } else {
      setMessage(undefined);
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (success) {
    return (
      <ResultadoDaAcao title="Mandou bem!" onClose={() => closeModal()}>
        O feedback contribui com o engajamento e desenvolvimento de sua equipe.
      </ResultadoDaAcao>
    );
  }

  return (
    <ConfirmacaoDaAcao
      title="Feedback opcional sobre essa Realização Destaque"
      subtitle={data?.title}
      size="md"
      onClose={() => closeModal()}
      onConfirm={() => {
        handleSubmit();
      }}
      confirmLabel="Enviar feedback"
      confirmDisabled={!message || !message.trim().length || message.trim().length < 20}
    >
      <div>
        <label htmlFor="feedback-textarea" className="mb-1.5 block text-jj-label font-semibold text-content-soft">
          Se quiser, você pode deixar um feedback para a equipe sobre a Realização Destaque!
        </label>
        <textarea
          id="feedback-textarea"
          className={CAMPO_DA_ACAO}
          rows={4}
          maxLength={200}
          minLength={20}
          onChange={e => setMessage(e.target.value)}
          defaultValue={message}
          aria-describedby="feedback-limites feedback-char-count"
        ></textarea>
        {/* D3: 10px não tem degrau no Tailwind. O mínimo explica por que "Enviar feedback" segue desabilitado (WCAG 3.3.2). */}
        <div className="mt-1.5 flex items-start justify-between gap-3 text-[10px] text-content-soft">
          <p id="feedback-limites" className="m-0">
            Mínimo de 20 e máximo de 200 caracteres.
          </p>
          <p id="feedback-char-count" className="m-0 shrink-0">
            {typeof message === 'string' ? message?.trim().length : 0}
            /200
          </p>
        </div>
      </div>
    </ConfirmacaoDaAcao>
  );
}
